var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "no-post alert alert-warning", attrs: { role: "alert" } },
    [_vm._v("There are no posts found.")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }